import { render, staticRenderFns } from "./ShifttypeFields.vue?vue&type=template&id=7af8adf2"
import script from "./ShifttypeFields.vue?vue&type=script&lang=js"
export * from "./ShifttypeFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports